export default "__VITE_ASSET__BetWt6IS__"